import { render, staticRenderFns } from "./reverse-relevance.vue?vue&type=template&id=7b6e7884&scoped=true&"
import script from "./reverse-relevance.vue?vue&type=script&lang=ts&"
export * from "./reverse-relevance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e7884",
  null
  
)

export default component.exports